import React from "react";
import { Grid, List, ListItem, Box, Hidden, Drawer } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import { compose, Query } from "react-apollo";
import { graphql } from "react-apollo";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as QueryString from "query-string";
import Location from "./location";
import Cuisines from "./cuisines";
import Schedule from "./schedule";
import EngagementPrice from "./price";
import EngagementSize from "./size";
import VerifyChef from "./verify";
import CancelationPolicy from "./cancelation-policy";
import PayoutInfo from "./payout";
import Portfolio from "./portfolio";
import { checkValidDate } from "../../utils/validate-data";
import style from "./style";
import Header from "../../components/Header";
import Footer from "../../components/Footer/FooterChefSteps";
import { connect } from "react-redux";
import UPDATE_CHEF from "../../graphql/mutations/chef/update_chef";
import VERIFY_CHEF from "../../graphql/mutations/chef/verify_chef";
import {
  CREATE_CHEF_WEEKLY_SCHEDULE,
  UPDATE_CHEF_WEEKLY_SCHEDULE,
  CREATE_CANDIDATE
} from "../../graphql/mutations/chef";
import ADD_CARD from "../../graphql/mutations/chef/add_payment";
import { GET_CHEF, GET_CHEF_DETAILS } from "../../graphql/queries/chef";
import { UPDATE, ADD_TO_STRIPE } from "../../graphql/mutations/user";
import {
  GET_CHEF_PAYMENT,
  GET_CHEF_WEEKLY_SCHEDULES
} from "../../graphql/queries/chef";
import { CUISINES } from "../../graphql/queries/dishes";
import {setBecomeChef, setIsChef, setChefStep, showBecomeMsg} from "../../redux/auth";
import SubscriptionPage from "./subscription";
import {validateAddress} from "../../utils/address-validation";

class Setup extends React.Component {
  state = {
    dinerHover: false,
    chefHover: false,
    blogHover: false,
    loginHover: false,
    logoutHover: false,
    dinerSelected: false,
    chefSelected: false,
    blogSelected: false,
    loginSelected: false,
    openDrawer: false,
    openLoginDrawer: false,
    showLogin: true,
    showForgotPassword: false,
    showSignUp: false,
    isChef: false,
    open: false,
    openPasswordDrawer: false,
    showFurtherMessage: false
  };

  constructor(props) {
    super(props);
    let chefStep = 1;
    const { location } = props;
    if (location && location.search) {
      const params = QueryString.parse(location.search);
      if (params) {
        chefStep = params.step ? parseInt(params.step) : 1;
      }
    }

    this.state = {
      currentRoute: "",
      step: chefStep,
      stepFinal: chefStep,
      loading: false,
      steps: [
        {
          header: "STEP 1",
          text: "Your location",
          id: 1
        },
        {
          header: "STEP 2",
          text: "Cuisines",
          id: 2
        },
        {
          header: "STEP 3",
          text: "Schedule",
          id: 3
        },
        {
          header: "STEP 4",
          text: "Engagement details",
          id: 4
        },
        /*{
          header: "STEP 5",
          text: "Engagement price",
          id: 5
        },*/
        {
          header: "STEP 5",
          text: "Subscription",
          id: 5
        },
        {
          header: "STEP 6",
          text: "Payout info.",
          id: 6
        },
        {
          header: "STEP 7",
          text: "Verify",
          id: 7
        },
        {
          header: "STEP 8",
          text: "Cancelation policy",
          id: 8
        },
        {
          header: "STEP 9",
          text: "Portfolio setup",
          id: 9
        }
      ],
      cardId: "",
      address: {},
      cuisines: [],
      maxDiners: "",
      minEngagementPrice: "",
      hourlyPrice: "",
      payout: {},
      verify: {},
      cancelationPolicy: {},
      hideSteps: false,
      scheduleCreated: false,
      subscription: null,
      isCardMandatoryOnVerify: true
    };
  }

  toggleDrawer = () => {
    this.setState({ openDrawer: !this.state.openDrawer });
  };

  toggleLoginDrawer = () => {
    this.setState({ openLoginDrawer: !this.state.openLoginDrawer });
  };

  closeLoginDrawer = () => {
    this.setState({ openLoginDrawer: false, showLogin: true, showForgotPassword: false, showSignUp: false });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      if (nextProps.location && nextProps.location.state) {
        const { step, hideSteps } = nextProps.location.state;
        this.props.details.refetch();

        if(step)
        this.setState({ step, hideSteps });
      }
    }
  }

  componentWillMount() {
    const { userId, history, dispatch, location, showBecomeChefMsg } = this.props;
    dispatch(setBecomeChef(false));
    if (!userId) {
      history.push("/");
    }
  }

  setLoading = value => {
    this.setState({ loading: value });
  };

  handleClick = step => {
    this.setState({ step }, () => {
      this.routeStep();
    });
    if (step !== 8) {
      window.onload = function() {
        window.scrollTo(0, 0);
      };
    }
  };

  routeStep = async () => {
    const { history, dispatch } = this.props;
    let { step } = this.state;

    await dispatch(setChefStep(step));

    dispatch(setIsChef(true));

    this.props.updateChef({
      variables: {
        chef: {
          userId: this.props.userId,
          completedSetupStep: step
        }
      }
    });

    await history.push(`?step=${step}`);
  };

  handleChefPayoutSubmit = async (updatePayout, values) => {
    const { dispatch } = this.props;
    dispatch(setIsChef(true));
    let payout = Object.assign({}, values);
    let { updateChef, userId, details, updateUser } = this.props;
    this.setState({ loading: true, payout: values });
    const dob = moment(values.dob).format("YYYY/MM/DD");
    const dateRegex = /^([12]\d{3}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01]))$/;

    if (!dateRegex.test(dob)) {
      this.setState({ loading: false });
      NotificationManager.error("Error parsing date of birth. Please try again as MM/DD/YYYY.", "Payout Info");
      return;
    }

    if (!checkValidDate(moment(values.dob).format('MM/DD/YYYY'))) {
      NotificationManager.error(
        "Please enter valid date.",
        "Chef Verification"
      );
      this.setState({ loading: false });
      return;
    }

    if (values.ssn.trim().length !== 11) {
      this.setState({ loading: false });
      NotificationManager.error("Invalid Social Security Number", "Payout Info");
      return;
    }

    const selectedDate = moment(dob);
    const checkDate = moment().subtract(18, 'year');

    if (!selectedDate.isBefore(checkDate)) {
      this.setState({ loading: false });
      NotificationManager.error("You should be 18+", "Payout Info");
      return;
    }

    const userUpdate = {
      userId,
      dateOfBirth: dob.replace(/\//g, "-"),
      taxId: values.ssn,
      active: true,
      completedSetupStep: this.state.stepFinal > 7 ? this.state.stepFinal : 7,
      stripeRecipientAgreementAccepted: values.stripeRecipientAgreementAccepted
    };

    try {
      await updateUser({
        variables: {
          user: {
            id: userId,
            cellPhone: values.mobile
          }
        },
      });
      const resp = await updateChef({
        variables: {
          chef: userUpdate
        }
      });
      if (resp) {
        delete payout.confirmAccount;
        delete payout.ssn;
        delete payout.dob;
        delete payout.mobile;
        delete payout.stripeRecipientAgreementAccepted;

        updatePayout({
          variables: {
            chefId: userId,
            payout: { type: "ACH", achAccount: payout }
          }
        })
          .then(res => {
            this.setState({ step: this.state.step + 1, loading: false }, () => {
              this.routeStep();
            });
            details.refetch();
          })
          .catch(err => {
            let errorObj = JSON.parse(JSON.stringify(err));
            if (errorObj.graphQLErrors) {
              errorObj.graphQLErrors.map(error => {
                NotificationManager.error(error.message, "Payout Info.");
              });
            }
            this.setState({ loading: false });
          });
      }
    } catch (err) {
      this.setLoading(false);
      let errorObj = JSON.parse(JSON.stringify(err));
      if (errorObj.graphQLErrors) {
        errorObj.graphQLErrors.map(error => {
          NotificationManager.error(error.message, "Payout Info.");
        });
        // const errMsg = errorObj.graphQLErrors[0].message;
      }
    }

    if (this.state.step !== 7) {
      window.onload = function() {
        window.scrollTo(0, 0);
      };
    }
  };

  addUserPayment = async values => {
    const { dispatch } = this.props;
    dispatch(setIsChef(true));
    const { userId, addPayment, addUserToStripe, refetch } = this.props;
    const expMonth = values.expiry.split("/")[0];
    const expYear = values.expiry.split("/")[1];
    this.setLoading(true);

    const payload = {
      userId,
      payment: {
        type: "CARD",
        card: {
          number: values.cardNumber,
          cvc: values.cvv,
          expMonth: parseInt(expMonth),
          expYear: parseInt(expYear)
        }
      }
    };
    try {
      const addToStripeRes = await addUserToStripe({
        variables: { userId }
      });
      if (addToStripeRes) {
        const paymentRes = await addPayment({
          variables: payload
        });
        if (paymentRes && paymentRes.data.addUserPayment && paymentRes.data.addUserPayment !== null) {
          NotificationManager.info("New Card added Successfully", "Add Card");
          this.setLoading(false);
          await this.props.fetchChefPayments.refetch();
        }
        else {
          NotificationManager.info("Card already added", "Add Card");
          this.setLoading(false);
          await this.props.fetchChefPayments.refetch();
        }
      }
    } catch (err) {
      this.setLoading(false);
      let errorObj = JSON.parse(JSON.stringify(err));
      if (errorObj.graphQLErrors) {
        errorObj.graphQLErrors.map(error => {
          NotificationManager.error(error.message, "Chef Verification");
        });
        // const errMsg = errorObj.graphQLErrors[0].message;
      }
    }

    if (this.state.step !== 6) {
      window.onload = function() {
        window.scrollTo(0, 0);
      };
    }
  };

  setSubscriptionAndCardOnVerify = (subscription, isCardMandatoryOnVerify) => {
    this.setState({
      subscription,
      isCardMandatoryOnVerify
    });
  };

  verifyChefInfo = async values => {
    let { verifyChef, createCandidate, userId } = this.props;
    const { subscription, isCardMandatoryOnVerify } = this.state;
    const { dispatch } = this.props;
    dispatch(setIsChef(true));

    /*if (isCardMandatoryOnVerify) {
      if (this.props.fetchChefPayments.error) {
        NotificationManager.error(
          "Please enter card details to continue.",
          "Chef Verification"
        );
        return;
      }

    }*/

    /*if (!checkValidDate(moment(values.dob).format('MM/DD/YYYY'))) {
      NotificationManager.error(
        "Please enter valid date to continue",
        "Chef Verification"
      );
      return;
    }*/

    const selectedDate = moment(values.dob);
    const checkDate = moment().subtract(18, 'year');

    /*if (!selectedDate.isBefore(checkDate)) {
      this.setState({ loading: false });
      NotificationManager.error("You should be 18+", "Chef Verification");
      return;
    }

    if (isNaN(parseInt(values.phone)) || values.phone.toString().length !== 10) {
      this.setState({ loading: false });
      NotificationManager.error(
        "Please enter a valid 10 digit mobile number",
        "Chef verification"
      );
      return;
    }*/

    this.setState({ verify: values });
    /*const payload = {
      //dob: values.dob ? moment(values.dob).format("YYYY/MM/DD") : null,
      firstName: values.firstName,
      lastName: values.lastName,
      /!*phone: values.phone,
      ssn: values.ssn,
      zipcode: values.zip,*!/
      email: values.email
    };*/

    const payload = {
      email: values.email,
      firstName: values.firstName,
      lastName: values.lastName,
    };

    try {
      this.setLoading(true);
      const {
        details: { chef }
      } = this.props;
      const createCandidateRes = await createCandidate({
        variables: {
          chef: {
            firstName: chef.firstName,
            lastName: chef.lastName,
            email: chef.emailId
          }
        }
      });
      try {
        const payData = await this.getPayload({});
        const resp = this.props.updateChef({
          variables: payData
        });
        if (resp) {
          this.props.details.refetch();
          NotificationManager.info('Thank you. We will get the ball rolling on getting you verified!', 'Chef verification');
          this.setState({ step: this.state.step + 1 }, () => {
            this.routeStep();
          });
          this.setLoading(false);
        }
        this.setLoading(false);
      } catch (err) {
        this.setLoading(false);
        console.log("Verify ERROR", err);
      }
      /*if (createCandidateRes) {
        const lastLength = this.props.fetchChefPayments.user.paymentInfo.length - 1;

        let verifyRes = null;

        /!*if (isCardMandatoryOnVerify) {
          verifyRes = await verifyChef({
            variables: {
              cardId: this.props.fetchChefPayments.user.paymentInfo[lastLength]
                .card.cardId
            }
          });
        } else {
          verifyRes = await verifyChef({
            variables: {
              cardId: "nocard"
            }
          });
        }*!/

        verifyRes = await verifyChef({
          variables: {
            cardId: "nocard"
          }
        });

        if (verifyRes.data) {
          this.setLoading(false);
          try {
            const resp = this.props.updateChef({
              variables: this.getPayload({})
            });
            if (resp) {
              this.props.details.refetch();
              this.setState({ step: this.state.step + 1 }, () => {
                this.routeStep();
              });
            }
          } catch (err) {
            console.log("Verify ERROR", err);
          }
        }
      }*/
    } catch (err) {
      this.setLoading(false);

      let errorObj = JSON.parse(JSON.stringify(err));
      if (errorObj.graphQLErrors) {
        errorObj.graphQLErrors.map(error => {
          if (error.message.indexOf("Circular") > -1) {
            error.message = "Invalid SSN";
          }
          NotificationManager.error(error.message, "Chef verification");
        });
      }
    }
    window.onload = function() {
      window.scrollTo(0, 0);
    };
  };

  subscriptionSuccess = () => {
    const { dispatch, updateChef, userId } = this.props;
    dispatch(setIsChef(true));
    this.setLoading(false);
    this.setState({ step: this.state.step + 1 }, () => {
      this.routeStep();
      updateChef({
        variables: {
          chef: {
            userId,
            active: true,
            completedSetupStep: 6
          }
        }
      });
    });
  };

  policySuccess = () => {
    const { dispatch } = this.props;
    dispatch(setIsChef(true));
    this.setLoading(false);
    this.setState({ step: this.state.step + 1 }, () => {
      this.routeStep();
    });
  };

  getPayload = async values => {
    const { userId, location , dispatch} = this.props;
    let step = 1;
    let path = null;
    if (location && location.search) {
      const params = QueryString.parse(location.search);
      if (params) {
        step = params.step ? parseInt(params.step) : 1;
      }
    }
    let payload = { chef: { userId } };


    if (step >= this.state.stepFinal) {
      this.setState({stepFinal:step})
      payload.chef.completedSetupStep=step;
      dispatch(setChefStep(step));
    }

    if (step === 1) {
      const address = Object.assign({}, values);
      payload.chef.canFly = values.canFly;
      payload.chef.maxTravelDistance = values.maxTravelDistance;
      delete address.canFly;
      delete address.maxTravelDistance;
      payload.chef.address = address;

      const addrStr = values.street1 + ' ' + values.street2 + ', ' + values.city + ', ' + values.state + ' ' + values.zip;
      const addrValidResp = await validateAddress(addrStr, values.city);

      if (addrValidResp.length) {
        NotificationManager.error('The address is invalid. Please input a valid one.', 'Address', 4500);
        document.getElementById('location-submit').disabled = false;
        return;
      }

      this.setState({
        address: values,
        distance: values.maxTravelDistance,
        canFly: values.canFly
      });
    } else if (step === 2) {
      payload.chef.cuisines = values.cuisines;
      this.setState({ cuisines: values.cuisines });
    } else if (step === 4) {
      let maxDiners = values.size;
      if (maxDiners == null || maxDiners == undefined || maxDiners === '') {
        maxDiners = 0;
      }
      payload.chef.maxDiners = maxDiners ? parseInt(maxDiners) : 0;
      payload.chef.minEngagementPrice = parseFloat(values.price);
      payload.chef.hourlyPrice = parseFloat(values.hourlyPrice);

      if (payload.chef.maxDiners) {
        if (payload.chef.maxDiners <= 0) {
          payload.chef.maxDiners = 0;
        }
      }

      this.setState({ maxDiners: maxDiners, minEngagementPrice: values.price });
    } /*else if (step === 5) {
      payload.chef.minEngagementPrice = parseFloat(values.price);
      this.setState({ minEngagementPrice: values.price });
    }*/ else if (step === 5) {
      return payload;
    }

    return payload;
  };

  handleSubmit = mutation => async (
    values,
    { setSubmitting, setStatus, resetForm }
  ) => {
    if (this.state.step !== 6) {
      window.onload = function() {
        window.scrollTo(0, 0);
      };
    }
    setSubmitting(true);

    if (this.state.step === 4) {
      this.updateAcceptance();
    }

    const payload = await this.getPayload(values);

    this.setLoading(true);
    mutation({
      variables: payload
    })
      .then(res => {
        this.setLoading(false);
        this.props.details.refetch();
        this.setState({ step: this.state.step + 1 }, () => {
          this.routeStep();
        });
      })
      .catch(err => {
        console.log('cuisinerror',err);
        this.setLoading(false);

        setSubmitting(false);
        setStatus(err);

        let errorObj = JSON.parse(JSON.stringify(err));
        if (errorObj.graphQLErrors) {
          errorObj.graphQLErrors.map(error => {
            NotificationManager.error(error.message, "Chef");
          });
        }
      });
  };

  onSubmit = async (mutate, input) => {
    const { userId } = this.props;

    try {
      this.setState({ loading: true });

      const payloadData = await this.getPayload(input);

      const resp = await mutate({
        variables: payloadData
      });

      if (resp.data) {
        this.setState({ loading: false, step: this.state.step + 1 }, () => {
          this.routeStep();
          const { dispatch, isChef } = this.props;
          if (!isChef) {
            dispatch(setIsChef(true));
          }
        });

        if (this.props.details && this.props.details.refetch) this.props.details.refetch();
      }

      if (resp.errors) {
        this.setState({ loading: false });
        const errMsg = resp.errors[0].message;
      }
    } catch (err) {
      this.setState({ loading: false });

      let errorObj = JSON.parse(JSON.stringify(err));

      if (errorObj.graphQLErrors) {
        errorObj.graphQLErrors.map(async error => {
          if (error.message === "Chef already registered") {
            const payloadData = await this.getPayload(input);
            const resp = this.props.updateChef({
              variables: payloadData
            });
            if (resp) {
              this.props.details.refetch();
              this.setState({step: this.state.step + 1 }, () => {
              this.routeStep();
              });
            }
          }
          // NotificationManager.error(error.message, 'Chef Verification');
        });
      }
    }
  };

  handelChefSchedules = async formData => {
    const {
      createWeeklySchedule,
      updateWeeklySchedule,
      schedules,
      userId
    } = this.props;

    if (
      formData.filter(day => {
        return day.selected;
      }).length <= 0
    ) {
      NotificationManager.error(
        "Please specify schedules to continue",
        "Chef Schedules"
      );
      return;
    }
    const isCreated =
      schedules.chefSchedule &&
      schedules.chefSchedule.daySchedules &&
      !!schedules.chefSchedule.daySchedules.length;

    let slot = {};
    if (!formData.length > 0) {
      if (!isCreated) {
        NotificationManager.error(
          "Please specify schedules to continue",
          "Chef Schedules"
        );
        return;
      }
      this.setState({ scheduleCreated: true });
      return;
    }
    this.setLoading(true);

    const seletedDays = formData.filter(day => {
      return day.slots.length > 0;
    });
    const updateDays = seletedDays.map(day => {
      return day.value;
    });
    let slots =[];
    const createPayload = seletedDays.map(d => {
      return {
        day: d.value,
        slots: d.slots.map(s => {
          slot = { start: s.start, end: s.end };
          slots.push(slot);
          if (s.from && s.to) {
            const start =
              s.from === "AM"
                ? s.start
                : `${parseInt(s.start.split(":")[0]) + 12}:${
                    s.start.split(":")[1]
                  }`;
            const end =
              s.to === "AM"
                ? s.end
                : `${parseInt(s.end.split(":")[0]) + 12}:${
                    s.end.split(":")[1]
                  }`;
            return { start, end };
          } else {
            return s;
          }
        })
      };
    });

    if (isCreated) {
      this.setLoading(false);
      this.setState({ scheduleCreated: true });
      /*this.setState({ step: 4 }, () => {
        this.routeStep();
      });*/
      /*let payload = await {
        chefId: userId,
        days: updateDays,
        slot: slot
      };

      try {
        const updateResp = await updateWeeklySchedule({
          variables: payload
        });
        if (updateResp) {
          await schedules.refetch();
          this.setLoading(false);
          this.setState({ step: 4 }, () => {
            this.routeStep();
          });
        }
      } catch (err) {
        let errorObj = JSON.parse(JSON.stringify(err));

        this.setLoading(false);
      }*/
    } else {
      let payload = {
        chefId: userId,
        weekschedule: {
          daySchedules: createPayload
        }
      };

      try {
        const createResp = await createWeeklySchedule({
          variables: payload
        });

        if (createResp) {
          this.setLoading(false);

          await schedules.refetch();
          try {
            const pData = await this.getPayload({});
            const resp = this.props.updateChef({
              variables: pData
            });
            if (resp) {
              this.props.details.refetch();
              this.setState({ scheduleCreated: true });
             /* this.setState({ step: 4 }, () => {
                this.routeStep();
              });*/
            }
          } catch (err) {
            console.log(err);
          }

          // NotificationManager.error(error.message, 'Chef Verification');
        }
        /*this.setState({ step: 4 }, () => {
          this.routeStep();
        });*/
      } catch (err) {
        let errorObj = JSON.parse(JSON.stringify(err));
        console.log(errorObj);
        this.setLoading(false);
      }
    }
  };

  scheduleNextScreen = () => {
    const { scheduleCreated } = this.state;
    const { schedules } = this.props;
    const allowNext =  schedules.chefSchedule && schedules.chefSchedule.daySchedules && schedules.chefSchedule.daySchedules.length > 0 ? true : false;

    if  (scheduleCreated || allowNext) {
      this.setState({ step: 4 }, () => {
        this.routeStep();
      });
    } else {
      NotificationManager.error('Please specify schedules to continue', 'Chef Schedules');
    }
  };

  onSavePortfollo = async payload => {
    let { updateChef, updateUser, userId, location, dispatch } = this.props;
    const { chef, user } = payload;
    this.setState({ loading: true ,step: 10});
    chef.completedSetupStep=11;
    try {
      const resp = await updateChef({
        variables: { chef }
      });
      if (resp) {
        await dispatch(setChefStep(10));
        dispatch(setBecomeChef(false));

          if (!!user && !!user.profilePic) {
            const respUser = await updateUser({
              variables: { user: { ...user, id: userId } }
            });
            if (respUser) {
              await this.props.history.push("/home/dashboard");
            }
            else {
              await this.props.history.push("/home/dashboard");
            }
          }
          else {
            await this.props.history.push("/home/dashboard");
          }
      }
    } catch (err) {
      this.props.history.push("/home/dashboard");
      let errorObj = JSON.parse(JSON.stringify(err));
      console.log(errorObj);
      if (errorObj.graphQLErrors) {
        errorObj.graphQLErrors.map(error => {
          console.log(error.message);
          if (error.message == "'$set' is empty. You must specify a field like so: {$set: {<field>: ...}}") {
             dispatch(setChefStep(9));
             this.props.history.push("/home/dashboard");
          }
        });
      }
      this.setState({ loading: false });
    }
  };

  updateAcceptance = async () => {
    let { updateChef, userId } = this.props;

    updateChef({
      variables: {
        chef: {
          userId,
          chefPrivacyTerms: true
        }
      }
    })
  };

  render() {
    let {
      cuisines,
      address,
      maxDiners,
      minEngagementPrice,
      hourlyPrice,
      payout,
      distance,
      canFly
    } = this.state;
    let { details, schedules, location } = this.props;
    if (details) {
      if (details.chef) {
        if (details.chef.payoutMethod) {
          const { payoutMethod } = details.chef;
          const [{ routingNumber, bankName }] = payoutMethod;
          payout = { ...payout, routingNumber, bankName };
        }
      }
    }
    let step = 1;
    let path = "";
    let hideSteps = false;
    if (location && location.search) {
      const params = QueryString.parse(location.search);
      if (params) {
        step = params.step ? parseInt(params.step) : 1;
        hideSteps = params.path && params.path === "portfolio";
      }
    }

    return (
      <div>
        <Header history={this.props.history} />
        {this.state.loading && <LinearProgress color="primary" />}
        <Hidden xsDown>
          <Grid container className="saved-item-container become-chef-step">
              {!hideSteps && (
                <Box className="left-container">
                  <p className="located-text super-title-steps">
                    Steps to get setup as a Chef
                  </p>
                  <List className="list-column">
                    {this.state.steps.map(item => (
                      <ListItem
                        key={item.id}
                        button
                        disabled={item.id > this.state.stepFinal}
                        onClick={() => this.handleClick(item.id)}
                        style={{ ...style.itemStyle, ...style.textFont, justifyContent: 'flex-start'}}
                      >
                        <div>
                          <p
                            style={
                              step <= item.id ? style.stepNumber : style.stepNumberUnselected
                            }
                          >
                            {item.header}
                          </p>
                          <p
                            style={
                              step === item.id
                                ? style.stepSelected
                                : item.id < step
                                ? style.stepText
                                : style.stepUnselected
                            }
                          >
                            {item.text}
                          </p>
                        </div>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              )}
            <Query query={GET_CHEF} variables={{ id: this.props.userId }}>
              {({ loading, error, data, refetch, networkStatus }) => {
                if (!error && loading)
                  return (
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="primary" />
                    </div>
                  );
                return (
                  <Box className="chef-right-container">
                    <div className="setup-as-chef-title">
                      Get set up as a Chef and start earning!
                    </div>
                    {step === 1 && (
                      <Location
                        onSubmit={this.onSubmit}
                        loading={this.state.loading}
                        data={
                          details && details.chef ? details.chef.address : address
                        }
                        distance={
                          details && details.chef
                            ? details.chef.maxTravelDistance || 0
                            : distance || 0
                        }
                        canFly={
                          details && details.chef
                            ? details.chef.canFly || false
                            : canFly || true
                        }
                      />
                    )}
                    {step === 2 && (
                      <Cuisines
                        onSubmit={this.handleSubmit}
                        selected={
                          details && details.chef
                            ? details.chef.cuisines || []
                            : cuisines || []
                        }
                        cuisines={this.props.cuisinesList.cuisines}
                      />
                    )}
                    {step === 3 && (
                      <Schedule
                        onSubmit={this.handelChefSchedules}
                        nextScreen={this.scheduleNextScreen}
                        schedules={
                          schedules.chefSchedule &&
                          schedules.chefSchedule.daySchedules
                            ? schedules.chefSchedule.daySchedules
                            : []
                        }
                        loading={this.state.loading}
                      />
                    )}
                    {step === 4 && (
                      <EngagementSize
                        maxDiners={
                          details && details.chef
                            ? details.chef.maxDiners
                            : maxDiners
                        }
                        minEngagementPrice={
                          details && details.chef
                            ? details.chef.minEngagementPrice
                            : minEngagementPrice
                        }
                        hourlyPrice={
                          details && details.chef
                            ? details.chef.hourlyPrice
                            : minEngagementPrice
                        }
                        chefPrivacyTerms={
                          details && details.chef
                            ? details.chef.chefPrivacyTerms
                            : false
                        }
                        onSubmit={this.handleSubmit}
                        updateAcceptance={this.updateAcceptance}
                      />
                    )}
                    {/*{step === 5 && (
                      <EngagementPrice
                        minEngagementPrice={
                          details && details.chef
                            ? details.chef.minEngagementPrice
                            : minEngagementPrice
                        }
                        onSubmit={this.handleSubmit}
                      />
                    )}*/}
                    {step === 5 && (
                      <SubscriptionPage
                        loading={this.state.loading}
                        onSuccess={this.subscriptionSuccess}
                      />
                    )}
                    {step === 6 && (
                      <PayoutInfo
                        payout={payout}
                        onSubmit={this.handleChefPayoutSubmit}
                        skip={() => {
                          this.setState({ step: this.state.step + 1 }, () => {
                            this.routeStep();
                          });
                        }}
                        loading={this.state.loading}
                        details={details || {}}
                        values={data || {}}
                      />
                    )}
                    {step === 7 && (
                      <VerifyChef
                        onVerify={this.verifyChefInfo}
                        onSaveCard={this.addUserPayment}
                        onSkip={() => this.handleClick(this.state.step + 1)}
                        values={data || {}}
                        details={details || {}}
                        loading={this.state.loading}
                        fetchPayments={this.props.fetchChefPayments}
                        userId={this.props.userId}
                        setSubscirptionAndCard={this.setSubscriptionAndCardOnVerify}
                      />
                    )}
                    {step === 8 && (
                      <CancelationPolicy
                        onSkip={() => this.handleClick(this.state.step + 1)}
                        loading={this.state.loading}
                        onSuccess={this.policySuccess}
                        setLoading={this.setLoading}
                      />
                    )}
                    {step === 9 && (
                      <Portfolio
                        onCuisinesSubmit={this.handleSubmit}
                        chef={details && details.chef ? details.chef : null}
                        selected={
                          details && details.chef
                            ? details.chef.cuisines || []
                            : cuisines || []
                        }
                        {...this.props}
                        cuisines={this.props.cuisinesList.cuisines || []}
                        onSubmit={this.onSavePortfollo}
                        updatePortfolio={this.state.hideSteps}
                      />
                    )}
                  </Box>
                );
              }}
            </Query>
          </Grid>
        </Hidden>

        <Hidden smUp>
          <Grid container className="saved-item-container become-chef-step">
            <div className="setup-as-chef-title">
              Get set up as a Chef and start earning!
            </div>
            <p className="located-text super-title-steps">
              Steps to get setup as a Chef
            </p>
              {!hideSteps && (
                <Box className="left-container">
                  <List className="list-column">
                    {this.state.steps.map(item => (
                      <ListItem
                        key={item.id}
                        button
                        disabled={item.id > this.state.stepFinal}
                        onClick={this.toggleLoginDrawer}
                        style={{ ...style.itemStyle, ...style.textFont, justifyContent: 'flex-start'}}
                      >
                        <div>
                          <p
                            style={
                              step <= item.id ? style.stepNumber : style.stepNumberUnselected
                            }
                          >
                            {item.header}
                          </p>
                          <p
                            style={
                              step === item.id
                                ? style.stepSelected
                                : item.id < step
                                ? style.stepText
                                : style.stepUnselected
                            }
                          >
                            {item.text}
                          </p>
                        </div>
                      </ListItem>
                    ))}
                  </List>
                  <Drawer
                    openLoginDrawer={this.state.openLoginDrawer}
                    toggleLoginDrawer={this.toggleLoginDrawer}
                    closeLoginDrawer={this.closeLoginDrawer}
                    handleLoginToggle={this.handleLoginToggle}
                  />
                </Box>
              )}
            <Query query={GET_CHEF} variables={{ id: this.props.userId }}>
              {({ loading, error, data, refetch, networkStatus }) => {
                if (!error && loading)
                  return (
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="primary" />
                    </div>
                  );
                return (
                  <Box className="chef-right-container">
                    {step === 1 && (
                      <Location
                        onSubmit={this.onSubmit}
                        loading={this.state.loading}
                        data={
                          details && details.chef ? details.chef.address : address
                        }
                        distance={
                          details && details.chef
                            ? details.chef.maxTravelDistance || 0
                            : distance || 0
                        }
                        canFly={
                          details && details.chef
                            ? details.chef.canFly || false
                            : canFly || true
                        }
                      />
                    )}
                    {step === 2 && (
                      <Cuisines
                        onSubmit={this.handleSubmit}
                        selected={
                          details && details.chef
                            ? details.chef.cuisines || []
                            : cuisines || []
                        }
                        cuisines={this.props.cuisinesList.cuisines}
                      />
                    )}
                    {step === 3 && (
                      <Schedule
                        onSubmit={this.handelChefSchedules}
                        nextScreen={this.scheduleNextScreen}
                        schedules={
                          schedules.chefSchedule &&
                          schedules.chefSchedule.daySchedules
                            ? schedules.chefSchedule.daySchedules
                            : []
                        }
                        loading={this.state.loading}
                      />
                    )}
                    {step === 4 && (
                      <EngagementSize
                        maxDiners={
                          details && details.chef
                            ? details.chef.maxDiners
                            : maxDiners
                        }
                        minEngagementPrice={
                          details && details.chef
                            ? details.chef.minEngagementPrice
                            : minEngagementPrice
                        }
                        hourlyPrice={
                          details && details.chef
                            ? details.chef.hourlyPrice
                            : minEngagementPrice
                        }
                        chefPrivacyTerms={
                          details && details.chef
                            ? details.chef.chefPrivacyTerms
                            : false
                        }
                        onSubmit={this.handleSubmit}
                        updateAcceptance={this.updateAcceptance}
                      />
                    )}
                    {/*{step === 5 && (
                      <EngagementPrice
                        minEngagementPrice={
                          details && details.chef
                            ? details.chef.minEngagementPrice
                            : minEngagementPrice
                        }
                        onSubmit={this.handleSubmit}
                      />
                    )}*/}
                    {step === 5 && (
                      <SubscriptionPage
                        loading={this.state.loading}
                        onSuccess={this.subscriptionSuccess}
                      />
                    )}
                    {step === 6 && (
                      <PayoutInfo
                        payout={payout}
                        onSubmit={this.handleChefPayoutSubmit}
                        skip={() => {
                          this.setState({ step: this.state.step + 1 }, () => {
                            this.routeStep();
                          });
                        }}
                        loading={this.state.loading}
                        details={details || {}}
                        values={data || {}}
                      />
                    )}
                    {step === 7 && (
                      <VerifyChef
                        onVerify={this.verifyChefInfo}
                        onSaveCard={this.addUserPayment}
                        onSkip={() => this.handleClick(this.state.step + 1)}
                        values={data || {}}
                        details={details || {}}
                        loading={this.state.loading}
                        fetchPayments={this.props.fetchChefPayments}
                        userId={this.props.userId}
                        setSubscirptionAndCard={this.setSubscriptionAndCardOnVerify}
                      />
                    )}
                    {step === 8 && (
                      <CancelationPolicy
                        onSkip={() => this.handleClick(this.state.step + 1)}
                        loading={this.state.loading}
                        onSuccess={this.policySuccess}
                        setLoading={this.setLoading}
                      />
                    )}
                    {step === 9 && (
                      <Portfolio
                        onCuisinesSubmit={this.handleSubmit}
                        chef={details && details.chef ? details.chef : null}
                        selected={
                          details && details.chef
                            ? details.chef.cuisines || []
                            : cuisines || []
                        }
                        {...this.props}
                        cuisines={this.props.cuisinesList.cuisines || []}
                        onSubmit={this.onSavePortfollo}
                        updatePortfolio={this.state.hideSteps}
                      />
                    )}
                  </Box>
                );
              }}
            </Query>
          </Grid>
        </Hidden>

        <Footer />
      </div>
    );
  }

  componentDidUpdate(nextProps) {
    if (this.state.step < 6) {
      window.history.pushState(null, null, window.location.href);
      window.onpopstate = function() {
        window.history.go(1);
      };
    }

    if (this.state.step !== 5) {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    // if (
    //   !!this.props.location &&
    //   !!this.props.location.state &&
    //   this.props.location.state.step !== nextProps.location.state.step
    // ) {
    //   const {
    //     location: {
    //       state: { step, about }
    //     }
    //   } = this.props;
    //   this.setState({ step, about });
    // }
  }

  componentDidMount() {
    const { location, showBecomeChefMsg, dispatch } = this.props;
    if (location && location.state) {
      const { hideSteps, step } = location.state;
      if (hideSteps) {
        this.setState({ hideSteps, step });
      }
      return;
    }

    let step = 1;
    if (location && location.search) {
      const params = QueryString.parse(location.search);

      if (params) {
        step = params.step ? parseInt(params.step) : 1;
      }

      if (params.showMsg === 'yes' && showBecomeChefMsg === 'no') {
        dispatch(showBecomeMsg('yes'));
        NotificationManager.info('Please finish giving the needed information so you can become a chef.', 'Become a chef', 4000);
        window.history.pushState({}, document.title, `/home/become-chef?step=${step}`);
      }
    }

    if (!!this.props.details && !this.state.loading) {
      if (!!this.props.details.chef) {
        const { completedSetupStep: step } = this.props.details.chef;
        if (step !== this.state.step) {
          this.setState({ step });
          this.setState({ stepFinal:step });
        }
      }
    }
  }
}

const mapSateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    showBecomeChefMsg: state.auth.showBecomeChefMsg,
  };
};
const ChefSetupWithData = compose(
  graphql(UPDATE_CHEF, { name: "updateChef" }),
  graphql(UPDATE, { name: "updateUser" }),
  graphql(VERIFY_CHEF, { name: "verifyChef" }),
  graphql(ADD_CARD, { name: "addPayment" }),
  graphql(ADD_TO_STRIPE, { name: "addUserToStripe" }),
  graphql(CREATE_CHEF_WEEKLY_SCHEDULE, { name: "createWeeklySchedule" }),
  graphql(UPDATE_CHEF_WEEKLY_SCHEDULE, { name: "updateWeeklySchedule" }),
  graphql(CREATE_CANDIDATE, { name: "createCandidate" }),

  graphql(GET_CHEF_PAYMENT, {
    name: "fetchChefPayments",
    options: props => ({
      variables: {
        id: props.userId
      }
    })
  }),
  graphql(CUISINES, {
    name: "cuisinesList",
    options: props => ({
      variables: {
        country: "US"
      }
    })
  }),
  graphql(GET_CHEF_DETAILS, {
    name: "details",
    options: props => ({
      variables: {
        id: props.userId
      }
    })
  }),
  graphql(GET_CHEF_WEEKLY_SCHEDULES, {
    name: "schedules",
    options: props => ({
      variables: {
        chefId: props.userId
      }
    })
  })
)(Setup);
const ChefStep = connect(mapSateToProps)(ChefSetupWithData);
export default ChefStep;
